import React from 'react';
import { Alert } from '../Ui/Alert';

export const TabPanel = ({ children, disabled = false, disabledMessage = null }) => {
  return (
    <div style={{ paddingTop: '10px' }}>
      {disabledMessage && <Alert type='warning'>{disabledMessage}</Alert>}
      <div style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}>
        {children}
      </div>
    </div>
  );
};
